import urls from '../api/urls';
// @ts-ignore
import { Config } from 'redhotpie-shared-lib/types/config';

// for react native
const location = {
  protocol: 'https',
};

// for react nativeCon
const ReactNative = {
  isProduction: process.env.REACT_APP_IS_PRODUCTION === 'true',
};

const config: Config = {
  appState: '',
  isAndroidPlayStore: false,
  requiredVersions: null,
  stableVersion: null,
  bundleID: null,
  autoSignIn: false,
  isNeedUpdate: false,
  isCheckedAppVersion: false,
  isMaintenance: false,
  isRequiredUpdate: false,
  xmppURL: urls.XMPP_IMURL,
  apiURL: urls.BASE_URL,
  fileURL: urls.BASE_RHPURL,
  https: true,
  isMultiLoginSessions: true,
  isWindowSDK: false,
  isSandBox: false,
  isDebug: false,
  simulateSendMessageFailed: false,
  allowLogWebSocketStatus: false,
  autoReconnectNumMax: 5,
  autoReconnectInterval: 3,
  autoReloginInterval: 10,
  isWebRTC: /WebKit/.test(<string>navigator.userAgent) && /^https\:$/.test(window.location.protocol),
  isAutoLogin: true,
  delivery: false,
  read: true,
  encrypt: {
    type: 'none',
  },
  isHttpDNS: false,
  isAutoSelectFirstConversation: true,
  domain: urls.XMPP_BASE,
  token: '',
  rhpToken: '',
  rhpAnonymousToken: '',
  gettingRhpToken: false,
  stopGettingRhpToken: false,
  rhpRefreshToken: '',
  rhpAPI_KEY: 'dc776231-6862-48f7-ae65-7fd72048bd63',
  preloadConversationDetail: false,
  delete: true,
  update: true,
  chatState: true,
  isMessagingAuthorization: true,
  isVideoAuthorization: true,
  getChatMessageFromExternalSystem: false,
  gotoMainSettingChatRoomTimeout: null,
  isProduction: ReactNative.isProduction,
  limitSecondTimeGetGroupChatMessage: 600,
  timeGetConversation: 1,
  heartBeatWait: 120000,
  pingTimeout: 5000,
  requestDeliveredTimeout: 10000,
  isHeartBeatEnable: true,
  isConnected: true,
  noNetworkEventFirerRef: null,
  eventChatStateRef: null,
  logOut: null,
  getOutChatRoom: null,
  callbackAfterJoinGroup: null,
  callbackDestroyAllLivestreams: null,
  handleReceiveBlockedMessage: null,
  handleResetSelectedConversation: null,
  scrollToEndGroupChat: null,
  DeviceOS: null,
  isDisableLiveStream: false,
  isLiveTryAgain: true,
  isEnabledDraggableVideoCall: false,
  appkey: (process.env.REACT_APP_XMPP_PREFIX as string) || (ReactNative.isProduction ? 'rhp#production' : 'rhp#testing'),
  networkUp: true,
  newConnOnOnlineTimeoutRef: null,
  newConnOnClosedTimeoutRef: null,
  numberOfUnackMsgToCheckForReceipt: 3,
  jumpToProspects: null,
  isEnableStreamManagementFeature: false,
  onMessageDeliverySuccess: null,
  onProfileSummaryNotFound: null,
  isUserInValid: false,
  shouldHandleBackground: true,
  geoLocation: {},
  appleAuthIsSupported: false,
  isOpenChangeUsernameModal: false,
  isAppOnBackground: false,
  sendReadMessage: null,
  modalCannotConnectSocialAccount: null,
  logDeviceInfo: null,
  appVersionsControl: {},
  isInMaintenance: false,
  failedRequest: [],
  versions: null,
  doNotShowScreenForce: false,
  conversationGoBack: () => void 0,
  rqAth: false,
  logServiceVersion: '1.0.3',
  setMessageBufferStorage: () => void 0,
  getMessageBufferStorage: () => void 0,
  sendToastMsg: () => void 0,
  goBackEventGroupChat: () => void 0,
  onUploadVideoMessengerError: () => void 0,
  onAbortUploadVideoMessenger: () => void 0,
  oneMessageOneReactionFromUser: true,
  goBackBlogDetails: null,
  goBackTopicDetails: null,
  goBackEventDetails: null,
  forceSendGiftDevelopment: false,
  metricsStatus: 'fold',
  notificationHistory: () => void 0,
  delayNotification: {},
  handleNotification: () => void 0,
  handleSendJoinedGroupMessage: null,
  effectAfterRemoveConversation: () => void 0,
  simulatePassAccessChatRoom: null,
  useCustomStartScreenLiveness: false,
  videoUploadController: {},
  highestCoinUnitPriceIOS: 0,
  isEnableScreenShot: false,
  callbackJoinGroup: null,
  isCompressVideo: false,
  blockScrollTop: false,
  initNavigationFlowGroupMainPage: false,
  askBiometricFunction: undefined,
};

export default config;
